import React, { useState } from 'react';
import { Modal } from '../Modal';
import { Form, InputNumber } from 'antd';
import { FormattedMessage } from 'react-intl';

function CustomValueModal({ open, onCancel, onSubmit }) {
  const [value, setValue] = useState(100)

  return (
    <Modal.Root visible={open}>
      <Modal.Header
        onCancelAction={onCancel}
        title={<FormattedMessage id="page.my_account.financial.value_modal.title" />}
      />
      <Modal.Content>
        <Form layout='vertical'>
          <Form.Item label={<FormattedMessage id="page.my_account.financial.value_modal.input" />}>
            <InputNumber
              className='w-full'
              defaultValue={value}
              min={10}
              formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
              onChange={setValue}
            />
          </Form.Item>
        </Form>
      </Modal.Content>
      <Modal.Actions
        submitText={<FormattedMessage id="page.my_account.financial.value_modal.confirm" />}
        onCancelAction={onCancel}
        onSubmitAction={() => onSubmit(value)}
      />
    </Modal.Root>
  );
}

export default CustomValueModal;